<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" class="detaile" [hidden]="!loading"></mat-progress-bar>
    <span>
        گزارش فاکتورهای اخیر
    </span>
    <span class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </span>
</div>

<div mat-dialog-content class="matDialogContent" style="overflow-y: hidden;">
    <div class="row">


        <div class="content-body control-content-body" style="max-height: 20rem;">
            <mat-table [dataSource]="dataSource" class='table-scroll pe1'>

                <ng-container matColumnDef="row">
                    <mat-header-cell *matHeaderCellDef style="max-width:45px">
                        #
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" style="max-width:45px">{{ i + 1 }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="invoice_date">
                    <mat-header-cell *matHeaderCellDef>
                        <span>تاریخ فاکتور فروش</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">
                        {{ x.wharehouse_order_document_date }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="invoice_number">
                    <mat-header-cell *matHeaderCellDef>
                        <span>شماره فاکتور</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">
                        <div>{{ x.wharehouse_invoice_number }}</div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="invoice_price">
                    <mat-header-cell *matHeaderCellDef>
                        <span>قیمت</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)="select(i)">
                        <div>{{ x.wharehouse_order_cost | number }}</div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns2" color="primary"></mat-header-row>
                <mat-row *matRowDef="let x;let i = index;columns:displayedColumns2"></mat-row>
            </mat-table>

        </div>
    </div>
    <!-- **************************************************************************************************** -->
</div>